import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const TestimonialsSection = styled.section`
  padding: 100px 0;
  background: #0a0a0a;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled(motion.h2)`
  font-family: "Playfair Display", serif;
  font-size: clamp(2.5rem, 5vw, 4rem);
  text-align: center;
  color: #ffffff;
  margin-bottom: 4rem;

  span {
    color: #ffd700;
  }
`;

const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const TestimonialCard = styled(motion.div)`
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding: 3rem;
  border-radius: 20px;
  position: relative;

  &:before {
    content: '"';
    position: absolute;
    top: 20px;
    left: 30px;
    font-size: 4rem;
    color: #ffd700;
    font-family: "Playfair Display", serif;
    opacity: 0.3;
  }
`;

const TestimonialText = styled.p`
  color: #ffffff;
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 2rem;
  font-style: italic;
`;

const TestimonialAuthor = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const AuthorAvatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffd700 0%, #ffa500 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
`;

const AuthorInfo = styled.div``;

const AuthorName = styled.h4`
  color: #ffd700;
  font-size: 1.2rem;
  margin-bottom: 0.2rem;
`;

const AuthorTitle = styled.p`
  color: #b0b0b0;
  font-size: 0.9rem;
`;

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      text: "Ferman transformed my language learning journey. The AI tutors are incredibly intuitive and the luxury experience is unmatched.",
      author: "Sarah Chen",
      title: "CEO, Tech Startup",
      avatar: "👩",
    },
    {
      id: 2,
      text: "Finally, a platform that understands professionals need efficiency. I achieved conversational fluency in just 3 months!",
      author: "Ahmed Al-Rashid",
      title: "Investment Banker",
      avatar: "👨",
    },
    {
      id: 3,
      text: "The personalized approach and premium quality materials make Ferman worth every penny. Highly recommended!",
      author: "Maria Rodriguez",
      title: "International Lawyer",
      avatar: "👩‍💼",
    },
  ];

  return (
    <TestimonialsSection id="testimonials">
      <Container>
        <SectionTitle
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Success <span>Stories</span>
        </SectionTitle>

        <TestimonialsGrid>
          {testimonials.map((testimonial, index) => (
            <TestimonialCard
              key={testimonial.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <TestimonialText>{testimonial.text}</TestimonialText>
              <TestimonialAuthor>
                <AuthorAvatar>{testimonial.avatar}</AuthorAvatar>
                <AuthorInfo>
                  <AuthorName>{testimonial.author}</AuthorName>
                  <AuthorTitle>{testimonial.title}</AuthorTitle>
                </AuthorInfo>
              </TestimonialAuthor>
            </TestimonialCard>
          ))}
        </TestimonialsGrid>
      </Container>
    </TestimonialsSection>
  );
};

export default Testimonials;
